// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3xLnc","range":"MonthRangeSwitch_range__1Skr5","disabled":"MonthRangeSwitch_disabled__Gw0TC"};